import { combineReducers } from 'redux'
import { type UsersState } from '../../../interfaces/users'
import getAllCoachesReducer from './getAllCoaches.reducer'

const userReducer = combineReducers<UsersState>({
  getAllCoaches: getAllCoachesReducer
})

export default userReducer
